import React from 'react';
import HeaderButton from './ui/HeaderButton';
import { useDispatch } from 'react-redux';
import { setMobileMenuOpen } from '../../Actions/Navigation.action';
import { translate } from '../../Services/translation';

const Navigation = () => {
  const dispatch = useDispatch();

  return (
    <HeaderButton
      icon="Menu"
      onClick={() => dispatch(setMobileMenuOpen(true))}
      hideOnDesktop={true}
      label={translate('general.menu')}
    />
  );
};

export default Navigation;
